export default __webpack_public_path__ + "static/media/press_room_thumb10.9e23619e.png";